<template>
    <svg
        width="660"
        height="564"
        viewBox="0 0 660 564"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0 133C0 126.373 5.37258 121 12 121H648C654.627 121 660 126.373 660 133V246C660 252.627 654.627 258 648 258H12C5.37257 258 0 252.627 0 246V133Z"
            fill="var(--et-colors-card-background)"
        />
        <path
            d="M12 274.5H648C654.351 274.5 659.5 279.649 659.5 286V399C659.5 405.351 654.351 410.5 648 410.5H12C5.64871 410.5 0.5 405.351 0.5 399V286C0.5 279.649 5.64873 274.5 12 274.5Z"
            fill="var(--et-colors-card-background)"
        />
        <path
            d="M0 439C0 432.373 5.37258 427 12 427H648C654.627 427 660 432.373 660 439V552C660 558.627 654.627 564 648 564H12C5.37257 564 0 558.627 0 552V439Z"
            fill="var(--et-colors-card-background)"
        />
        <text
            fill="var(--et-colors-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="36"
            font-weight="600"
            letter-spacing="-1px"
        >
            <tspan x="276.676" y="58.2001">Pricing</tspan>
        </text>
        <text
            fill="#475467"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="16"
            letter-spacing="0em"
        >
            <tspan x="228.398" y="90.2001">Choose best option for you.</tspan>
        </text>
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="20"
            letter-spacing="0em"
        >
            <tspan x="16" y="156">Base</tspan>
        </text>
        <path d="M439.5 242V137" stroke="#F2F4F7" />
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="24"
            letter-spacing="0em"
        >
            <tspan x="530.5" y="176.3">$29</tspan>
        </text>
        <path
            d="M472 194H636C640.142 194 643.5 197.358 643.5 201.5V217.5C643.5 221.642 640.142 225 636 225H472C467.858 225 464.5 221.642 464.5 217.5V201.5C464.5 197.358 467.858 194 472 194Z"
            stroke="var(--et-colors-border)"
        />
        <path
            d="M12 274.5H648C654.351 274.5 659.5 279.649 659.5 286V399C659.5 405.351 654.351 410.5 648 410.5H12C5.64871 410.5 0.5 405.351 0.5 399V286C0.5 279.649 5.64873 274.5 12 274.5Z"
            stroke="var(--et-colors-brand)"
        />
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="20"
            letter-spacing="0em"
        >
            <tspan x="16" y="309">Standard</tspan>
        </text>
        <path d="M439.5 395V290" stroke="#F2F4F7" />
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="24"
            letter-spacing="0em"
        >
            <tspan x="530.5" y="317.8">$49</tspan>
        </text>
        <text
            fill="#667085"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
            text-decoration="line-through"
        >
            <tspan x="542" y="344.4">$59</tspan>
        </text>
        <path
            d="M472 358.5H636C640.142 358.5 643.5 361.858 643.5 366V382C643.5 386.142 640.142 389.5 636 389.5H472C467.858 389.5 464.5 386.142 464.5 382V366C464.5 361.858 467.858 358.5 472 358.5Z"
            fill="var(--et-colors-brand)"
        />
        <path
            d="M472 358.5H636C640.142 358.5 643.5 361.858 643.5 366V382C643.5 386.142 640.142 389.5 636 389.5H472C467.858 389.5 464.5 386.142 464.5 382V366C464.5 361.858 467.858 358.5 472 358.5Z"
            stroke="var(--et-colors-border)"
        />
        <text
            fill="var(--et-colors-card-background)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="14"
            letter-spacing="0em"
        >
            <tspan x="528.5" y="378.3">Choose</tspan>
        </text>
        <path
            d="M357 262.5H302C295.649 262.5 290.5 267.649 290.5 274C290.5 280.351 295.649 285.5 302 285.5H357C363.351 285.5 368.5 280.351 368.5 274C368.5 267.649 363.351 262.5 357 262.5Z"
            fill="var(--et-colors-brand)"
        />
        <path
            d="M357 262.5H302C295.649 262.5 290.5 267.649 290.5 274C290.5 280.351 295.649 285.5 302 285.5H357C363.351 285.5 368.5 280.351 368.5 274C368.5 267.649 363.351 262.5 357 262.5Z"
            stroke="var(--et-colors-border)"
        />
        <text
            fill="var(--et-colors-card-background)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
        >
            <tspan x="300.297" y="277.9">Bestseller</tspan>
        </text>
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="20"
            letter-spacing="0em"
        >
            <tspan x="16" y="462">Premium</tspan>
        </text>
        <path
            d="M29.3337 210L22.0003 217.333L18.667 214M29.3337 363L22.0003 370.333L18.667 367M237.334 363L230 370.333L226.667 367M29.3337 516L22.0003 523.333L18.667 520M29.3337 536L22.0003 543.333L18.667 540M237.334 516L230 523.333L226.667 520"
            stroke="#079455"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M27.3337 230.667L20.667 237.333M20.667 230.667L27.3337 237.333M235.334 210.667L228.667 217.333M228.667 210.667L235.334 217.333M235.334 230.667L228.667 237.333M228.667 230.667L235.334 237.333M27.3337 383.667L20.667 390.333M20.667 383.667L27.3337 390.333M235.334 383.667L228.667 390.333M228.667 383.667L235.334 390.333M235.334 536.667L228.667 543.333M228.667 536.667L235.334 543.333"
            stroke="#D92D20"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M410 178H22C18.6863 178 16 180.686 16 184C16 187.314 18.6863 190 22 190H410C413.314 190 416 187.314 416 184C416 180.686 413.314 178 410 178Z"
            fill="#F2F4F7"
        />
        <path
            d="M166 208H42C38.6863 208 36 210.686 36 214C36 217.314 38.6863 220 42 220H166C169.314 220 172 217.314 172 214C172 210.686 169.314 208 166 208Z"
            fill="#F2F4F7"
        />
        <path
            d="M133 228H42C38.6863 228 36 230.686 36 234C36 237.314 38.6863 240 42 240H133C136.314 240 139 237.314 139 234C139 230.686 136.314 228 133 228Z"
            fill="#F2F4F7"
        />
        <path
            d="M369 208H250C246.686 208 244 210.686 244 214C244 217.314 246.686 220 250 220H369C372.314 220 375 217.314 375 214C375 210.686 372.314 208 369 208Z"
            fill="#F2F4F7"
        />
        <path
            d="M392 228H250C246.686 228 244 230.686 244 234C244 237.314 246.686 240 250 240H392C395.314 240 398 237.314 398 234C398 230.686 395.314 228 392 228Z"
            fill="#F2F4F7"
        />
        <path
            d="M410 331H22C18.6863 331 16 333.686 16 337C16 340.314 18.6863 343 22 343H410C413.314 343 416 340.314 416 337C416 333.686 413.314 331 410 331Z"
            fill="#F2F4F7"
        />
        <path
            d="M166 361H42C38.6863 361 36 363.686 36 367C36 370.314 38.6863 373 42 373H166C169.314 373 172 370.314 172 367C172 363.686 169.314 361 166 361Z"
            fill="#F2F4F7"
        />
        <path
            d="M133 381H42C38.6863 381 36 383.686 36 387C36 390.314 38.6863 393 42 393H133C136.314 393 139 390.314 139 387C139 383.686 136.314 381 133 381Z"
            fill="#F2F4F7"
        />
        <path
            d="M369 361H250C246.686 361 244 363.686 244 367C244 370.314 246.686 373 250 373H369C372.314 373 375 370.314 375 367C375 363.686 372.314 361 369 361Z"
            fill="#F2F4F7"
        />
        <path
            d="M392 381H250C246.686 381 244 383.686 244 387C244 390.314 246.686 393 250 393H392C395.314 393 398 390.314 398 387C398 383.686 395.314 381 392 381Z"
            fill="#F2F4F7"
        />
        <path
            d="M410 484H22C18.6863 484 16 486.686 16 490C16 493.314 18.6863 496 22 496H410C413.314 496 416 493.314 416 490C416 486.686 413.314 484 410 484Z"
            fill="#F2F4F7"
        />
        <path
            d="M166 514H42C38.6863 514 36 516.686 36 520C36 523.314 38.6863 526 42 526H166C169.314 526 172 523.314 172 520C172 516.686 169.314 514 166 514Z"
            fill="#F2F4F7"
        />
        <path
            d="M133 534H42C38.6863 534 36 536.686 36 540C36 543.314 38.6863 546 42 546H133C136.314 546 139 543.314 139 540C139 536.686 136.314 534 133 534Z"
            fill="#F2F4F7"
        />
        <path
            d="M369 514H250C246.686 514 244 516.686 244 520C244 523.314 246.686 526 250 526H369C372.314 526 375 523.314 375 520C375 516.686 372.314 514 369 514Z"
            fill="#F2F4F7"
        />
        <path
            d="M392 534H250C246.686 534 244 536.686 244 540C244 543.314 246.686 546 250 546H392C395.314 546 398 543.314 398 540C398 536.686 395.314 534 392 534Z"
            fill="#F2F4F7"
        />
        <path d="M439.5 548V443" stroke="#F2F4F7" />
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="24"
            letter-spacing="0em"
        >
            <tspan x="530.5" y="470.8">$69</tspan>
        </text>
        <text
            fill="#667085"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
            text-decoration="line-through"
        >
            <tspan x="542.5" y="497.4">$79</tspan>
        </text>
        <path
            d="M472 194H636C640.142 194 643.5 197.358 643.5 201.5V217.5C643.5 221.642 640.142 225 636 225H472C467.858 225 464.5 221.642 464.5 217.5V201.5C464.5 197.358 467.858 194 472 194Z"
            fill="none"
        />
        <path
            d="M472 511.5H636C640.142 511.5 643.5 514.858 643.5 519V535C643.5 539.142 640.142 542.5 636 542.5H472C467.858 542.5 464.5 539.142 464.5 535V519C464.5 514.858 467.858 511.5 472 511.5Z"
            fill="none"
        />
        <path
            d="M472 511.5H636C640.142 511.5 643.5 514.858 643.5 519V535C643.5 539.142 640.142 542.5 636 542.5H472C467.858 542.5 464.5 539.142 464.5 535V519C464.5 514.858 467.858 511.5 472 511.5Z"
            stroke="var(--et-colors-border)"
        />
    </svg>
</template>
